import { combineReducers } from "@reduxjs/toolkit";

// Reducers are imported from their slice files rather than feature barrels to
// keep the Storybook preview's dependency graph small. Chromatic TurboSnap
// falls back to a full rebuild when anything imported (transitively) by
// .storybook/preview.tsx changes, and the barrels drag in components.
import { answerReducer } from "@/features/answer/answer-slice/answer-slice";
import { assignmentReducer } from "@/features/assignment/assignment-slice";
import { authorityReducer } from "@/features/authority/authority-slice/authority-slice";
import { sentimentCheckReducer } from "@/features/sentiment-check/sentiment-check-slice";
import { socraticReducer } from "@/features/socratic/socratic-slice/socratic-slice";
import { timelineReducer } from "@/features/timeline/timeline-slice/timeline-slice";
import { layoutReducer } from "@/stores/layout-slice";

// Create the root reducer independently to obtain the RootState type
export const rootReducer = combineReducers({
  assignment: assignmentReducer,
  timeline: timelineReducer,
  layout: layoutReducer,
  authority: authorityReducer,
  answer: answerReducer,
  sentimentCheck: sentimentCheckReducer,
  socratic: socraticReducer,
});
